document.addEventListener('DOMContentLoaded', function () {
    BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function (event) {
        moveOptionsAfter(".bold_options_loaded", ".zpa-dynamic-product__inner-row .zpa-el-variant-selector");
    });
});

function moveOptionsAfter(targetSelector, referenceSelector) {
    const target = document.querySelector(targetSelector);
    const reference = document.querySelector(referenceSelector);

    if (target && reference) {
        reference.parentNode.insertBefore(target, reference.nextSibling);
    } else {
        console.warn("SCPO: Target or reference element not found.");
    }
}
